










































import Vue from 'vue';
import Component from 'vue-class-component';
import {acceptComment, getComments, rejectComment} from '@/clients/AdminCommentsClient';
import {Watch} from 'vue-property-decorator';
import {BvTableFieldArray} from 'bootstrap-vue';
import {ControlParams, CustomParams, EventParams} from 'vue-gtag2';
import {VueGtag} from 'vue-gtag';
import {format} from 'fecha';
import DisplayMarkup from '@/components/DisplayMarkup.vue';
import {DateFormats} from '@/types/DateFormats';
import LoadingPanel from '@/components/LoadingPanel.vue';

@Component({
  name: 'AdminComments',
  components: {LoadingPanel, DisplayMarkup},
})
export default class AdminComments extends Vue {
  public fields: BvTableFieldArray = [
    {key: 'created', label: 'Data utworzenia', class: 'min-width-150'},
    {key: 'body', label: 'Treść', class: 'w-50'},
    {key: 'actions', label: 'Akcje', class: 'text-center'},
  ];

  private comments: Array<Comment> = [];
  private isLoading = false;

  @Watch('$route', {immediate: true}) onRouteChange() {
    this.refresh();
  }

  private accept(id: string) {
    let success = false;
    acceptComment(id).then(response => {
      if (response.ok) {
        success = true;
        this.refresh();
      } else {
        this.$bvModal.msgBoxOk('Coś poszło nie tak');
      }
    }).catch(err => {
      this.$bvModal.msgBoxOk(`Coś poszło nie tak: ${err}`);
    }).finally(() => {
      this.trackAcceptEvent({success});
    });
  }

  private reject(id: string) {
    let success = false;
    rejectComment(id)
      .then(response => {
        if (response.ok) {
          success = true;
          this.refresh();
        } else {
          this.$bvModal.msgBoxOk('Coś poszło nie tak');
        }
      }).catch(err => {
        this.$bvModal.msgBoxOk(`Coś poszło nie tak: ${err}`);
      }).finally(() => {
        this.trackRejectEvent({success});
      });
  }

  private refresh() {
    this.isLoading = true;
    getComments().then(response => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json();
    }).then(data => {
      this.comments = data.comments;
    }).finally(() => {
      this.isLoading = false;
    });
  }

  private formatDate(dateStr: string): string {
    return format(new Date(dateStr), DateFormats.DATE_TIME);
  }

  private trackAcceptEvent(eventParams: ControlParams | EventParams | CustomParams): void {
    if (process.env.NODE_ENV === 'production') {
      (this.$gtag as VueGtag).event('acceptComment', eventParams);
    }
  }

  private trackRejectEvent(eventParams: ControlParams | EventParams | CustomParams): void {
    if (process.env.NODE_ENV === 'production') {
      (this.$gtag as VueGtag).event('rejectComment', eventParams);
    }
  }

  private getTexts(body: string): Array<string> {
    return body.split('\n');
  }
}
